import { render, staticRenderFns } from "./CertsPanel.vue?vue&type=template&id=62f3b702"
import script from "./CertsPanel.vue?vue&type=script&lang=js"
export * from "./CertsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f3b702')) {
      api.createRecord('62f3b702', component.options)
    } else {
      api.reload('62f3b702', component.options)
    }
    module.hot.accept("./CertsPanel.vue?vue&type=template&id=62f3b702", function () {
      api.rerender('62f3b702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/certificados/CertsPanel.vue"
export default component.exports